module.exports = __webpack_public_path__ + "static/media/insulttoinjury.ee0e42bc.jpg";